export default __webpack_public_path__ + "static/media/img.71b7a567.jpeg";